import { FormSchema } from 'src/hooks';
import { getTranslation } from 'src/utilities/translator';

export const LABEL_DISBURSEMENT = {
  title: {
    notificationConfiguration: 'DISBURSEMENT NOTIFICATION CONFIGURATION',
    productDisburse: 'PRODUCT DISBURSEMENT',
  },
  form: {
    bulkDisbursement: 'Bulk Disbursement',
    apiDisbursement: 'Api Disbursement',
    scheduledDisbursement: 'Scheduled Disbursement',
    email: 'Emails(s)',
  },
  placeholder: {
    email: 'Type the recipient(s) email',
  },
  message: {
    email:
      'Use (;) between email to differentiate them (Max. 3 emails or 255 characters)',
    submitNotification: 'Sucessfully update notification',
    failedSubmitNotification: 'Failed to create/update notification config: ',
    emailInvalid: 'Email address is invalid',
    maxEmailInvalid: 'Invalid max email',
    dataNotValid: 'Data Not Valid.',
    emailValid: 'Email is valid',
  },
  option: {
    enableSuccess: 'Enable Success Notification',
    disableSuccess: 'Disable Success Notification',
  },
  value: {
    true: 'true',
    false: 'false',
    enable: 'enable',
    disable: 'disable',
  },
  saveChanges: 'Save Changes',
};

//! MANY unused variables!!!
export const LABEL_RECEIVE_MONEY = {
  option: {
    enableSuccess: 'Enable Notification',
    disableSuccess: 'Disable Notification',
  },
  value: {
    enable: 'enable',
    disable: 'disable',
  },
};

export enum ReceiveMoneyProduct {
  PaymentCheckout = 'PAYMENT_CHECKOUT',
  VirtualAccount = 'VIRTUAL_ACCOUNT',
  Ewallet = 'EWALLET',
}

export const paymentCheckoutTypeConstant = [
  {
    value: LABEL_RECEIVE_MONEY.value.enable,
    label: getTranslation('common_enableSuccessNotification'),
    description: getTranslation('common_enableSuccessNotificationDescription'),
  },
  {
    value: LABEL_RECEIVE_MONEY.value.disable,
    label: getTranslation('common_disableSuccessNotification'),
    description: getTranslation('common_error_noSendingEmailNotification'),
  },
];

export const virtualAccountTypeConstant = [
  {
    value: LABEL_RECEIVE_MONEY.value.enable,
    label: getTranslation('common_enableSuccessNotification'),
    description: getTranslation('notification_virtualAccountType_desc_enable'),
  },
  {
    value: LABEL_RECEIVE_MONEY.value.disable,
    label: getTranslation('common_disableSuccessNotification'),
    description: getTranslation('common_error_noSendingEmailNotification'),
  },
];

export const ewalletTypeConstant = [
  {
    value: LABEL_RECEIVE_MONEY.value.enable,
    label: getTranslation('common_enableSuccessNotification'),
    description: getTranslation('notification_ewallettType_desc_enable'),
  },
  {
    value: LABEL_RECEIVE_MONEY.value.disable,
    label: getTranslation('common_disableSuccessNotification'),
    description: getTranslation('common_error_noSendingEmailNotification'),
  },
];

export enum NotificationReceiveMoneyFieldName {
  PaymentCheckout = 'PAYMENT_CHECKOUT',
  VirtualAccount = 'VIRTUAL_ACCOUNT',
  Ewallet = 'EWALLET',
  Logo = 'logo',
  Emails = 'emails',
}

export const NOTIFICATION_RECEIVE_MONEY_SCHEMA: FormSchema = {
  [NotificationReceiveMoneyFieldName.PaymentCheckout]: {
    initialValue: LABEL_RECEIVE_MONEY.value.disable,
    validationRule: 'required',
  },
  [NotificationReceiveMoneyFieldName.VirtualAccount]: {
    initialValue: LABEL_RECEIVE_MONEY.value.disable,
    validationRule: 'required',
  },
  [NotificationReceiveMoneyFieldName.Ewallet]: {
    initialValue: LABEL_RECEIVE_MONEY.value.disable,
    validationRule: 'required',
  },
  [NotificationReceiveMoneyFieldName.Logo]: {
    initialValue: '',
    validationRule: 'required|isLogoUrl',
    customErrorMessages: {
      required: getTranslation(
        'emailNotification_errorMessage_logoUrlRequired',
      ),
    },
  },
};

export enum NotificationDisbursementReceiver {
  SenderIdentity = 'senderIdentity',
  Email = 'recipientEmail',
}

export const LABEL_DISBURSEMENT_RECEIVER = {
  value: {
    brandName: 'BRAND_NAME',
    companyName: 'COMPANY_NAME',
  },
  saveSuccess: 'Successfully saved changes',
  saveChanges: 'Save Changes',
};

export const NOTIFICATION_DISBURSEMENT_RECEIVER_SCHEMA: FormSchema = {
  [NotificationDisbursementReceiver.SenderIdentity]: {
    initialValue: LABEL_DISBURSEMENT_RECEIVER.value.brandName,
    validationRule: 'required',
  },
  [NotificationDisbursementReceiver.Email]: {
    initialValue: '',
    validationRule: 'required|max:255',
    customErrorMessages: {
      required: getTranslation('common_emailRequired'),
      max: getTranslation('emailNotification_errorMessage_emailMax255char'),
    },
  },
};

export const senderNameInitialValue = [
  {
    value: LABEL_DISBURSEMENT_RECEIVER.value.brandName,
    label: getTranslation('common_brandName'),
    description: getTranslation('description_senderName'),
    isDisabled: false,
  },
  {
    value: LABEL_DISBURSEMENT_RECEIVER.value.companyName,
    label: getTranslation('common_companyName'),
    description: getTranslation('description_senderName'),
    isDisabled: false,
  },
];

export enum ContentType {
  LOW_BALANCE = 'LOW_BALANCE',
  SENDER_DISBURSEMENT = 'SENDER_DISBURSEMENT',
  RECEIVER_DISBURSEMENT = 'RECEIVER_DISBURSEMENT',
  SENDER_ACCEPTANCE = 'SENDER_ACCEPTANCE',
  RECEIVER_ACCEPTANCE = 'RECEIVER_ACCEPTANCE',
  EXPORT_EMAIL = 'EXPORT_EMAIL',
}

export const CONTENT = [
  {
    content: ContentType.LOW_BALANCE,
    label: getTranslation('notification_lowBalanceLabel'),
  },
  {
    content: ContentType.SENDER_DISBURSEMENT,
    label: getTranslation('notification_senderDisbursementLabel'),
  },
  {
    content: ContentType.RECEIVER_DISBURSEMENT,
    label: getTranslation('notification_receiverDisbursementLabel'),
  },
  {
    content: ContentType.SENDER_ACCEPTANCE,
    label: getTranslation('settings_notification_moneyReceiveToSender'),
  },
  {
    content: ContentType.RECEIVER_ACCEPTANCE,
    label: getTranslation('settings_notification_moneyReceiveToReceiver'),
  },
  {
    content: ContentType.EXPORT_EMAIL,
    label: getTranslation('asycDownload_tab_exportEmail'),
  },
];
